"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgDollar = function SvgDollar(_ref) {
  var fill = _ref.fill,
      theme = _ref.theme,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "theme", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm-.234-3.218c-.327 0-.503-.176-.503-.503v-2.087c-2.717-.151-4.603-1.66-5.257-3.572-.126-.327.05-.553.352-.629l1.283-.352c.302-.075.503.05.629.377.427 1.006 1.534 1.786 2.993 1.937v-5.207l-.78-.276c-3.094-.981-3.899-2.918-3.899-4.427 0-2.616 2.138-4.276 4.679-4.528V5.251c0-.327.176-.503.503-.503h.478c.327 0 .503.176.503.503v2.29c2.213.25 3.773 1.534 4.351 3.32.1.327-.05.553-.352.654l-1.207.377c-.302.1-.503-.025-.629-.327-.402-1.031-1.132-1.585-2.163-1.76v4.98l.855.326c2.691.83 4.05 2.616 4.05 4.402 0 2.641-2.013 4.377-4.905 4.679v2.087c0 .327-.176.503-.503.503h-.478zm-.503-12.55V9.778c-1.182.201-2.113.93-2.113 2.188 0 .654.15 1.535 1.987 2.214l.126.05zm1.484 7.696c1.484-.252 2.339-1.107 2.339-2.289 0-1.182-.905-1.836-2.213-2.314l-.126-.05v4.653z",
      fill: fill || theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "dollar_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 2,
      y: 2,
      width: 28,
      height: 28,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm-.234-3.218c-.327 0-.503-.176-.503-.503v-2.087c-2.717-.151-4.603-1.66-5.257-3.572-.126-.327.05-.553.352-.629l1.283-.352c.302-.075.503.05.629.377.427 1.006 1.534 1.786 2.993 1.937v-5.207l-.78-.276c-3.094-.981-3.899-2.918-3.899-4.427 0-2.616 2.138-4.276 4.679-4.528V5.251c0-.327.176-.503.503-.503h.478c.327 0 .503.176.503.503v2.29c2.213.25 3.773 1.534 4.351 3.32.1.327-.05.553-.352.654l-1.207.377c-.302.1-.503-.025-.629-.327-.402-1.031-1.132-1.585-2.163-1.76v4.98l.855.326c2.691.83 4.05 2.616 4.05 4.402 0 2.641-2.013 4.377-4.905 4.679v2.087c0 .327-.176.503-.503.503h-.478zm-.503-12.55V9.778c-1.182.201-2.113.93-2.113 2.188 0 .654.15 1.535 1.987 2.214l.126.05zm1.484 7.696c1.484-.252 2.339-1.107 2.339-2.289 0-1.182-.905-1.836-2.213-2.314l-.126-.05v4.653z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#dollar_svg__a)",
      children: (0, _jsxRuntime.jsx)("path", {
        fill: fill || theme.colors.primary.main,
        d: "M-59-59H90.747V91H-59z"
      })
    })]
  }));
};

var _default = SvgDollar;
exports["default"] = _default;